import { Chance } from "chance"
import { ExtractScheduleType } from "etl/types";

const chance = new Chance();

export const extractScheduleTypeFactoryMock = (howMany: number): ExtractScheduleType[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/extract_schedule_types/${index + 1}`,
		"@type": "ExtractScheduleType",
		id: index + 1,
		label: chance.word(),
		schedule_status: chance.word(),
		background_color: chance.word(),
		duration: chance.word(),
		action: chance.word(),
		aw_id: chance.integer().toString(),
		aw_company_id: chance.integer().toString(),
	}));
